















import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import BaseCart from '@/modules/common/cart/components/panel/BaseCart.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'

@Component({
  components: { BaseButton, BaseCart }
})
export default class PanelContentCampaignCart extends Vue {
  @Prop() payInfo!: any
  @Prop({ default: false }) nextButtonEnabled!: boolean
}
